import React from "react";
import renderSelectedItemsString from "../../../../utils/renderSelectedItemsString";
import optionsForProductSummary from "./optionsForProductSummary";

function GetOptionsForProduct(flatProduct) {
  return optionsForProductSummary(flatProduct).map((option) => {
    let subOptionValue2 = option.sub_options.length
      ? option.sub_options.map((subOption) =>
          renderSelectedItemsString(flatProduct, subOption)
        )
      : renderSelectedItemsString(flatProduct, option);
    optionsForProductSummary(flatProduct);
    return { [option.name]: subOptionValue2 };
  });
}

export default GetOptionsForProduct;
